import { graphql } from "react-apollo";
import { compose, withProps } from "recompose";

import withLocalization from "./withLocalization";
import withConnectionStatus from "./withConnectionStatus";

import generalTranslationsQuery from "../queries/generalTranslations";

const defaultTranslations = {
    EN: {
        feedback: "Feedback and Ideas for the App",
        disclaimer:
            "All information and images published in this web application are property of the MAN Truck & Bus AG. Their sole purpose is the internal use by MAN employees or contractual partners for the preparation of customer appointments. The forwarding to any third party is prohibited. The MAN Products & Solutions Tool may include optional extras subject to additional charges.",
        "not-found": "The page you requested cannot be found.",
        "login-user": "Email",
        "login-password": "Password",
        "login-error-wrong-credentials": "Wrong credentials",
        "login-register": "Register",
        "show-news": "See all news",
        "show-podcasts": "See all BusCasts",
        close: "Close",
        quit: "Quit",
        "generate-pdf": "Generate PDF",
        "w2p-mode-enabled": "Web-to-print mode on",
        "update-pwa": "Update App",
        "to-podcast": "To the podcast",
        "login-intro": "Log in with your MyBus credentials.",
    },
    DE: {
        feedback: "Feedback und Wünsche zur App",
        disclaimer:
            "Alle in dieser Web-Applikation veröffentlichten Informationen und Darstellungen sind Eigentum der MAN Truck & Bus AG. Sie werden ausschließlich für die interne Verwendung durch MAN Mitarbeiter oder Vertragspartner zum Zwecke der Vorbereitung auf Kundentermine zur Verfügung gestellt. Die Weiterleitung an jegliche Dritte ist untersagt. In dem MAN Products & Solutions Tool können aufpreispflichtige Sonderausstattungen enthalten sein.",
        "not-found": "Die angeforderte Seite konnte leider nicht gefunden werden.",
        "login-user": "E-Mail",
        "login-password": "Passwort",
        "login-error-wrong-credentials": "Ungültige Zugangsdaten",
        "login-register": "Registrieren",
        "show-news": "Alle News ansehen",
        "show-podcasts": "Alle BusCasts ansehen",
        close: "Schließen",
        quit: "Beenden",
        "generate-pdf": "PDF generieren",
        "w2p-mode-enabled": "Web-to-print Modus aktiv",
        "update-pwa": "App aktualisieren",
        "to-podcast": "Zum BusCast",
        "login-intro": "Melden Sie sich mit Ihren MyBus-Zugangsdaten an.",
    },
};

export default compose(
    withConnectionStatus,
    withLocalization,
    graphql(generalTranslationsQuery, {
        options: ({ language, fetchPolicy, stage }) => ({
            variables: {
                lang: language.toLowerCase(),
                stage,
            },
            fetchPolicy,
        }),
    }),
    withProps(({ language, data: { loading, generalTranslations, error } }) => {
        if ((loading && generalTranslations === undefined) || error) {
            // NOTE: needed for initial app load when user not yet logged in
            return {
                generalTranslations: (slug) =>
                    slug in defaultTranslations[language.toUpperCase()]
                        ? defaultTranslations[language.toUpperCase()][slug]
                        : "...",
            };
        }

        const allTranslations = generalTranslations.reduce((accum, { slug, translation }) => {
            accum[slug] = translation;
            return accum;
        }, defaultTranslations[language.toUpperCase()]);

        return {
            generalTranslations: (slug) => allTranslations[slug] || "...",
        };
    })
);



// WEBPACK FOOTER //
// ./src/hocs/withGeneralTranslations.js